import type { TFunction } from 'i18next';

import type { TChannel } from '../types';

/** Channel-specific configuration */
export interface IChannelConfig {
  /** FilePicker preset for this channel */
  preset: 'metaCreative' | 'displayCreative';
  /** Description text for the upload modal */
  description: string;
  /** Fields to skip validation on in CreativeModal */
  skipValidationFields?: string[];
}

/**
 * Gets channel-specific configuration for the upload modal.
 *
 * @param channel - The channel type
 * @param t - Translation function
 * @returns Configuration for the specified channel
 */
export function getChannelConfig(channel: TChannel, t: TFunction): IChannelConfig {
  switch (channel) {
    case 'meta':
      return {
        preset: 'metaCreative',
        description: t('Upload images or videos for your Meta creative.'),
        // Skip ad_video_id validation because Meta requires videos to be uploaded
        // to their platform before creating an ad. We defer this upload until save.
        skipValidationFields: ['ad_video_id'],
      };

    case 'display':
      return {
        preset: 'displayCreative',
        description: t('Upload images or videos for your Display creative.'),
      };
  }
}
